import React from 'react';
import { Link } from 'react-router-dom';
import logo from "../../../assets/Logo/logo.png"
import './Footer.css'


const Footer = () => {
    return (
        <footer className="footer items-center p-4 bg-neutral text-neutral-content">
            <div className="items-center grid-flow-col">
                <img src={logo} className="h-24" alt="img" />
                <p>Copyright © 2022 - All right reserved</p>
            </div>
            <div className="grid-flow-col justify-self-center gap-4 md:place-self-center md:justify-self-end">
                <a href="https://www.facebook.com/A.R.yasin111/"><i className="fa fa-facebook icon hover:text-blue-500 transition-all" aria-hidden="true"></i></a>
                <a href="https://www.linkedin.com/in/abdur-rahman-apu/"><i className="fa fa-linkedin icon hover:text-sky-500 transition-all" aria-hidden="true"></i></a>
                <a href="https://github.com/Abdur-Rahman-Apu"><i className="fa fa-github icon hover:transition-all" aria-hidden="true"></i></a>
            </div>
        </footer>
    );
};

export default Footer;